import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Slide } from '@mui/material';
import { Cookie } from 'lucide-react';

const STORAGE_KEY = 'ftm_cookie_consent_v1';

const CookieConsent = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      const accepted = localStorage.getItem(STORAGE_KEY);
      if (!accepted) {
        const t = setTimeout(() => setOpen(true), 600);
        return () => clearTimeout(t);
      }
    } catch {
      setOpen(true);
    }
  }, []);

  const accept = (level) => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ level, acceptedAt: new Date().toISOString() })
      );
    } catch {}
    setOpen(false);
  };

  if (!open) return null;

  return (
    <Slide direction="up" in={open} mountOnEnter unmountOnExit>
      <Box
        role="dialog"
        aria-live="polite"
        aria-label="Aviso de cookies e privacidade"
        sx={{
          position: 'fixed',
          bottom: { xs: 12, sm: 20 },
          left: { xs: 12, sm: 20 },
          right: { xs: 12, sm: 'auto' },
          maxWidth: { xs: 'calc(100% - 24px)', sm: 460 },
          zIndex: 2000,
          p: { xs: 2.25, sm: 2.75 },
          borderRadius: 3,
          background: 'rgba(20, 25, 38, 0.96)',
          backdropFilter: 'blur(14px)',
          border: '1px solid rgba(124, 58, 237, 0.35)',
          boxShadow: '0 20px 60px rgba(0,0,0,0.45)',
          color: '#E5E7EB',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 1.25 }}>
          <Box sx={{
            width: 36, height: 36, borderRadius: 2,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: 'linear-gradient(135deg, rgba(124, 58, 237, 0.25), rgba(124, 58, 237, 0.05))',
            color: '#A78BFA',
          }}>
            <Cookie size={20} strokeWidth={1.75} />
          </Box>
          <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: '1rem' }}>
            Sua privacidade importa
          </Typography>
        </Box>

        <Typography sx={{ color: '#9CA3AF', fontSize: '0.88rem', lineHeight: 1.55, mb: 2 }}>
          Utilizamos cookies essenciais para o funcionamento do Painel FTM e cookies analíticos
          para melhorar sua experiência. Ao continuar navegando, você concorda com nossos{' '}
          <Box component="a" href="/termos-de-uso" target="_blank" rel="noopener noreferrer" sx={{ color: '#A78BFA', textDecoration: 'underline' }}>
            Termos de Uso
          </Box>{' '}
          e nossa{' '}
          <Box component="a" href="/politica-de-privacidade" target="_blank" rel="noopener noreferrer" sx={{ color: '#A78BFA', textDecoration: 'underline' }}>
            Política de Privacidade
          </Box>{' '}
          (LGPD).
        </Typography>

        <Box sx={{ display: 'flex', gap: 1.25, flexWrap: 'wrap' }}>
          <Button
            variant="contained"
            size="small"
            onClick={() => accept('all')}
            sx={{ flex: 1, minWidth: 130, py: 1, borderRadius: 2 }}
          >
            Aceitar todos
          </Button>
          <Button
            variant="outlined"
            size="small"
            onClick={() => accept('essential')}
            sx={{
              flex: 1, minWidth: 130, py: 1, borderRadius: 2,
              borderColor: 'rgba(124, 58, 237, 0.4)', color: '#A78BFA',
              '&:hover': { borderColor: '#7C3AED', background: 'rgba(124, 58, 237, 0.08)' },
            }}
          >
            Somente essenciais
          </Button>
        </Box>
      </Box>
    </Slide>
  );
};

export default CookieConsent;
